// https://www.iconfont.cn/collections/detail?spm=a313x.7781069.1998910419.d9df05512&cid=25353
import Icon from '@ant-design/icons'
import React, { ComponentType, SVGProps } from 'react'

import AnalyticsFilledImage from '@/../public/images/icons/analytics.svg'
import ArchiveOutlinedImage from '@/../public/images/icons/archive-outlined.svg'
import AsanaOutlinedImaged from '@/../public/images/icons/asana-outlined.svg'
import AzureOutlinedImage from '@/../public/images/icons/azure-outlined.svg'
import BitBucketOutlinedImage from '@/../public/images/icons/bitbucket-outlined.svg'
import Org from '@/../public/images/icons/cloud.svg'
import ContributorsOutlinedImage from '@/../public/images/icons/contributors.svg'
import CpuOutlinedImage from '@/../public/images/icons/cpu.svg'
import DiscardDocumentOutlinedImage from '@/../public/images/icons/discard-document-outlined.svg'
import EnvironmentsFilledImage from '@/../public/images/icons/environments.svg'
import ExternalLinkOutlinedImage from '@/../public/images/icons/external-link.svg'
import GitBranchOutlinedImage from '@/../public/images/icons/git-branch.svg'
import GitCommitOutlinedImage from '@/../public/images/icons/git-commit.svg'
import GitRepositoryFilledImage from '@/../public/images/icons/git-repository.svg'
import JiraOutlinedImage from '@/../public/images/icons/jira-outlined.svg'
import MagicWandImage from '@/../public/images/icons/magic-wand.svg'
import MailOpenOutlinedImage from '@/../public/images/icons/mail-open-outlined.svg'
import MailOutlinedImage from '@/../public/images/icons/mail-outlined.svg'
import MailSentOutlinedImage from '@/../public/images/icons/mail-sent-outlined.svg'
import GitRepository from '@/../public/images/icons/repository.svg'
import TicketFilledImage from '@/../public/images/icons/ticket.svg'
import UnarchiveOutlinedImage from '@/../public/images/icons/unarchive-outlined.svg'
import UsersOutlinedImage from '@/../public/images/icons/users.svg'

import { IconBaseProps } from '@/types/components'

export function buildIcon(component: ComponentType<SVGProps<SVGSVGElement>>) {
  return function (props: IconBaseProps | StyleProps) {
    return <Icon component={component} {...props} />
  }
}

export type StyleProps = { style?: React.CSSProperties }

export const AnalyticsFilled = buildIcon(AnalyticsFilledImage)
export const ArchiveOutlined = buildIcon(ArchiveOutlinedImage)
export const AsanaOutlined = buildIcon(AsanaOutlinedImaged)
export const AzureOutlined = buildIcon(AzureOutlinedImage)
export const BitBucketOutlined = buildIcon(BitBucketOutlinedImage)
export const ContributorsOutlined = buildIcon(ContributorsOutlinedImage)
export const CpuOutlined = buildIcon(CpuOutlinedImage)
export const DiscardDocumentOutlined = buildIcon(DiscardDocumentOutlinedImage)
export const EnvironmentsFilled = buildIcon(EnvironmentsFilledImage)
export const ExternalLinkOutlined = buildIcon(ExternalLinkOutlinedImage)
export const Git = buildIcon(GitRepository)
export const GitBranchOutlined = buildIcon(GitBranchOutlinedImage)
export const GitCommitOutlined = buildIcon(GitCommitOutlinedImage)
export const GitRepositoryFilled = buildIcon(GitRepositoryFilledImage)
export const JiraOutlined = buildIcon(JiraOutlinedImage)
export const MagicWand = buildIcon(MagicWandImage)
export const MailOpenOutlined = buildIcon(MailOpenOutlinedImage)
export const MailOutlined = buildIcon(MailOutlinedImage)
export const MailSentOutlined = buildIcon(MailSentOutlinedImage)
export const SalesforceOrg = buildIcon(Org)
export const TicketFilled = buildIcon(TicketFilledImage)
export const UnarchiveOutlined = buildIcon(UnarchiveOutlinedImage)
export const UsersOutlined = buildIcon(UsersOutlinedImage)
